const IS_NODE = typeof process !== 'undefined' && process.versions != null && process.versions.node != null;
// This is for the "binary" loader (custom code is ~2x faster than "atob")
// from: https://github.com/evanw/esbuild/blob/150a01844d47127c007c2b1973158d69c560ca21/internal/runtime/runtime.go#L185
let __toBinary = IS_NODE
    ? (base64) => new Uint8Array(Buffer.from(base64, 'base64'))
    : /* @__PURE__ */ (() => {
        var table = new Uint8Array(128);
        for (var i = 0; i < 64; i++)
            table[i < 26 ? i + 65 : i < 52 ? i + 71 : i < 62 ? i - 4 : i * 4 - 205] = i;
        return (base64) => {
            var n = base64.length;
            // @ts-ignore
            var bytes = new Uint8Array((((n - (base64[n - 1] == '=') - (base64[n - 2] == '=')) * 3) / 4) | 0);
            for (var i = 0, j = 0; i < n;) {
                var c0 = table[base64.charCodeAt(i++)], c1 = table[base64.charCodeAt(i++)];
                var c2 = table[base64.charCodeAt(i++)], c3 = table[base64.charCodeAt(i++)];
                bytes[j++] = (c0 << 2) | (c1 >> 4);
                bytes[j++] = (c1 << 4) | (c2 >> 2);
                bytes[j++] = (c2 << 6) | c3;
            }
            return bytes;
        };
    })();
function initEmscriptenModule(moduleFactory, src) {
    const wasmBinary = __toBinary(src);
    return moduleFactory({ noInitialRun: true, wasmBinary });
}

export { initEmscriptenModule as i };
